export function setBaseUrl(name = 'default') {
  return (process.env.NODE_ENV == 'development'
    ? {
        default: '/api',
        ai: 'https://ai.yunqingsmart.com:9080'
      }
    : {
        default: 'https://apiuser.yunqingsmart.com',
        ai: 'https://ai.yunqingsmart.com:9080'
      })[name];
}
